<template>
		<div>
		<!-- <link href='https://fonts.googleapis.com/css?family=Lato|GFS+Didot|Montserrat:400,700' rel='stylesheet' type='text/css' />
		<table width="100%" border="0" cellpadding="0" cellspacing="0">
			<tr>
				<td bgcolor="#808080"><table align="center" width="100%" border="0" cellpadding="0" cellspacing="0">
					<tr>
						<td>
							<div id="header">
								<a href="http://www.brightoncollectibles.com/store" class="logoLink"><img src="https://www.brightoncollectibles.com/store/header_and_footer/grey/images/bc_logo.png?1" alt="Brighton Retailers" border="0" /></a>
							</div>
						</td>
					</tr>
				</table></td>
			</tr>
		</table> -->
		<div v-html="header"></div>
		<!-- <div v-html="footer"></div> -->
	</div>
</template>
<style scoped>
	#header{
		display:block;
	}
	#header a{
		display:block;
		margin:10px auto;
		text-align:left;
		max-width:1170px;
	}
	#header #search{
		display: inline-block;
		width: 50%;
		text-align: right;
	}
	#footer{
		text-align:center;
	}
	#footer ul{
		float: none;
	    display: inline-block
	}
			
</style>
<script>
	
export default {
  	name: 'brheader',
	props: {
		// storeType: Number
	},
	data: function () {
		return {
			header: '',
			footer: ''
		}
	},
	mounted () {
		this.$http.get('https://app.brighton.com/lockets/api/brightonHeader').then(response => {
		// this.$http.get('https://www.brighton.com/Shop/Export/header.php').then(response => {
			this.header = response.body
			this.$http.get('https://app.brighton.com/lockets/api/brightonFooter').then(response => {
				// this.footer = response.body
			})
		})
	}
}
</script>